/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SortDirection } from './SortDirection';
import {
    SortDirectionFromJSON,
    SortDirectionFromJSONTyped,
    SortDirectionToJSON,
    SortDirectionToJSONTyped,
} from './SortDirection';

/**
 * 
 * @export
 * @interface CategoryTreeNodeExtendedDtoSortingRequestDto
 */
export interface CategoryTreeNodeExtendedDtoSortingRequestDto {
    /**
     * Sortable fields for CategoryTreeNodeExtendedDto: code, name, fullName, description, ownOrderCount, ownOrderAmount, totalOrderAmount, totalOrderCount
     * @type {CategoryTreeNodeExtendedDtoSortingRequestDtoSortByEnum}
     * @memberof CategoryTreeNodeExtendedDtoSortingRequestDto
     */
    sortBy?: CategoryTreeNodeExtendedDtoSortingRequestDtoSortByEnum | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof CategoryTreeNodeExtendedDtoSortingRequestDto
     */
    sortDir?: SortDirection;
}


/**
 * @export
 */
export const CategoryTreeNodeExtendedDtoSortingRequestDtoSortByEnum = {
    code: 'code',
    name: 'name',
    fullName: 'fullName',
    description: 'description',
    ownOrderCount: 'ownOrderCount',
    ownOrderAmount: 'ownOrderAmount',
    totalOrderAmount: 'totalOrderAmount',
    totalOrderCount: 'totalOrderCount'
} as const;
export type CategoryTreeNodeExtendedDtoSortingRequestDtoSortByEnum = typeof CategoryTreeNodeExtendedDtoSortingRequestDtoSortByEnum[keyof typeof CategoryTreeNodeExtendedDtoSortingRequestDtoSortByEnum];


/**
 * Check if a given object implements the CategoryTreeNodeExtendedDtoSortingRequestDto interface.
 */
export function instanceOfCategoryTreeNodeExtendedDtoSortingRequestDto(value: object): value is CategoryTreeNodeExtendedDtoSortingRequestDto {
    return true;
}

export function CategoryTreeNodeExtendedDtoSortingRequestDtoFromJSON(json: any): CategoryTreeNodeExtendedDtoSortingRequestDto {
    return CategoryTreeNodeExtendedDtoSortingRequestDtoFromJSONTyped(json, false);
}

export function CategoryTreeNodeExtendedDtoSortingRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryTreeNodeExtendedDtoSortingRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sortBy': json['sortBy'] == null ? undefined : json['sortBy'],
        'sortDir': json['sortDir'] == null ? undefined : SortDirectionFromJSON(json['sortDir']),
    };
}

export function CategoryTreeNodeExtendedDtoSortingRequestDtoToJSON(json: any): CategoryTreeNodeExtendedDtoSortingRequestDto {
    return CategoryTreeNodeExtendedDtoSortingRequestDtoToJSONTyped(json, false);
}

export function CategoryTreeNodeExtendedDtoSortingRequestDtoToJSONTyped(value?: CategoryTreeNodeExtendedDtoSortingRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sortBy': value['sortBy'],
        'sortDir': SortDirectionToJSON(value['sortDir']),
    };
}

